import { VesselStatus } from '../../services/schedules-service';
import { CharacteristicsWithIMO } from '../../services/vessel-plans-service';
export interface PortCallActuals {
    pilotStationArrivalAt: string | null;
    pilotOnAt: string | null;
    arrivalAt: string | null;
    departureAt: string | null;
    pilotOffAt: string | null;
}

export interface SimplifiedPortCall {
    // Either gsisId or localId will always be set (localId will only be used for portcalls added locally)
    gsisId: null | number;
    localId: null | number;
    terminalCode: string;
    arrivalAt: string;
    arrivalVoyage?: string;
    departureAt: string;
    departureVoyage?: string;
    omitted: boolean;
    actuals: PortCallActuals;
    serviceCode?: string;
    vesselCode?: string;
    operatorCode?: string;
    estimatedPilotBoarding?: string;
    estimatedPilotDropOff?: string;
    estimatedpilotboarding?: string;
    estimatedpilotdropoff?: string;
}

export interface ScheduleEntry {
    id: string;
    departureTerminalCode: string;
    departureTerminalUnLocode: string | null;
    departureAt: string;
    arrivalTerminalCode: string;
    arrivalTerminalUnLocode: string | null;
    arrivalAt: string;
    etd: number;
    eta: number;
    progress: number;
    active?: boolean;
    inPort?: boolean;
    departureVoyage?: string;
    arrivalVoyage?: string;
    arrivalPortCall?: {
        current: SimplifiedPortCall;
        GSIS: SimplifiedPortCall | null;
    };
    departurePortCall?: {
        current: SimplifiedPortCall;
        GSIS: SimplifiedPortCall | null;
    };
    omitted?: boolean;
    isBprAvailable?: boolean;
    isBasicPlanAvailable?: boolean;
    isOORAvailable?: boolean;
    BprRouteIds?: string[] | null;
}

export interface ScheduleVesselAvailabilityGap {
    from: string;
    to: string;
}

export interface ScheduleVesselAvailability {
    name: string;
    firstPortCallArrivalAt: string;
    lastPortCallArrivalAt: string;
    gaps: ScheduleVesselAvailabilityGap[];
    isCurrentlyAvailable: boolean;
}

export interface CurrentScheduleState {
    startPort: string;
    endPort: string;
    startTime: number;
    endTime: number;
    inPort: boolean;
    serviceCode?: string | null;
    operatorCode?: string | null;
}

export interface IMOsCurrentScheduleState {
    imoNo: number;
    schedule: CurrentScheduleState;
}

export enum ScheduleEvents {
    ScheduleUpdated = 'schedule-updated',
    ScheduleStatesUpdated = 'schedule-states-updated'
}

export interface GetSchedulePromise {
    promise: Promise<ScheduleEntry[]>;
}

export interface ScheduleCacheEntry {
    timestamp: number;
    schedule: ScheduleEntry[];
}

export interface vesselInfo {
    code: string,
    imo: number,
    name: string,
    maerskOperated: boolean,
    updatedAt: string,
    operatorCode: string,
    teuCapacity: null,
    primaryVoyagePlanningTool: number | null,
}

export interface VesselStatusSchedule { 
    startPort: string,
    endPort: string,
    startTime: number,
    endTime: number,
    inPort: boolean,
    serviceCode: string | undefined,
    operatorCode: string | undefined,
    id?: string,
}

export type VesselStatusActual = VesselStatus & {
    id: string,
  }

export type VesselCharacteristicsIdb = CharacteristicsWithIMO & {
    id: string;
}

